import { useState, useEffect, useCallback } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import NotificationForm from './components/NotificationForm';
import NotificationMenu from './components/NotificationMenu';
import Page from '../../components/Page/Page';
import Headers from '../../components/Headers/Headers';
import Reload from '../../components/reload/reload';
import '../DashMedidas/DashMedidas.css';
import '../../styles/SguUnitsPage.css';
import './Notification.css';

const Notification = () => {
  const [loading, setLoading] = useState(true);

  const [units] = useState(
    JSON.parse(localStorage.getItem('units')) ||
    [JSON.parse(localStorage.getItem('cooperative'))] ||
    []
  );

  const [user,] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [filteredUnits, setFilteredUnits] = useState(units);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);

      if (units.length > 0 && !selectedUnit) {
        setSelectedUnit(units[0]);
      }
    }, 200);
    return () => clearTimeout(timeout);
  }, [units, selectedUnit]);

  const handleSearchData = useCallback((value) => {
    setSearchValue(value);
    const searchValueUpper = value.toUpperCase();
    const filtered = units.filter(item =>
      (item?.name?.toUpperCase().includes(searchValueUpper)) ||
      (item?.email?.toUpperCase().includes(searchValueUpper)) ||
      (item?.cnpj?.toUpperCase().includes(searchValueUpper))
    );
    setFilteredUnits(filtered);

    if (filtered.length > 0) {
      setSelectedUnit(filtered[0]);
    } else {
      setSelectedUnit(null);
    }
  }, [units]);

  const handleUnitSelect = (unit) => {
    setSelectedUnit(unit);
  };

  const unitsHeaderRight = selectedUnit ? (
    <span className="dash-section-card__header-meta">
      1 selecionada
    </span>
  ) : null;

  return (
    <Page title={"Notificações"}>
      <Headers page={"Notificações"} />
      {loading && <Reload />}

      <div className="dash-medidas-page dash-medidas-container notification-page sgu-units-page">
        <div className="dash-medidas-stack">
          <Row className="dash-medidas-grid g-3 sgu-units-main-row">
            <Col xs={12} md={4} lg={3} xl={3} className="sgu-units-col">
              <NotificationMenu
                user={user}
                units={filteredUnits}
                onUnitSelect={handleUnitSelect}
                onSearch={handleSearchData}
                selectedUnit={selectedUnit}
                searchValue={searchValue}
                headerRight={unitsHeaderRight}
              />
            </Col>

            <Col xs={12} md={8} lg={9} xl={9} className="sgu-units-content-col">
              <div className="dash-medidas-stack sgu-units-content-scroll">
                {selectedUnit ? (
                  <NotificationForm
                    user={user}
                    unit={selectedUnit}
                  />
                ) : (
                  <Alert
                    variant="warning"
                    className="text-center mb-0 sgu-empty-alert"
                  >
                    Selecione uma unidade para configurar as notificações
                  </Alert>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Page>
  );
};

export default Notification;
